
import { defineComponent } from "vue";

import Template from "@/components/Templates/index.vue";
import Careers from "@/components/Careers/Template1/index.vue";

export default defineComponent({
  components: {
    Careers,
    Template,
  },
});
